import { CoasVideoPreview } from "../utilities/youtubeVideo";
import { VideoLocalPreview } from "../utilities/video";
class videoImage {
    constructor() {
        this.containerVideoId = 'containerVideoId';
        this.containerLocalVideoId = 'containerLocalVideo';
        this.initPageConfig();
    }
    initPageConfig() {
        // Init video component
        const containerVideo = document.getElementById(this.containerVideoId);
        if (containerVideo) {
            const containerVideo = new CoasVideoPreview(this.containerVideoId);
            containerVideo.onInit();
        }
        const containerLocalVideo = document.getElementById(this.containerLocalVideoId);
        if (containerLocalVideo) {
            const containerVideo = new VideoLocalPreview(this.containerLocalVideoId);
            containerVideo.onInit();
        }
    }
}
window.addEventListener('load', function () {
    new videoImage();
});
